/* eslint-disable prefer-const */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable import/no-named-as-default */
/* eslint-disable import/no-unresolved */
/* eslint-disable react/self-closing-comp */
/* eslint-disable import/order */
/* eslint-disable object-shorthand */
/* eslint-disable prettier/prettier */
import { Icon } from '@iconify/react';
import { useEffect } from 'react';
import skipBackOutline from '@iconify/icons-eva/skip-back-outline';
import { Link as RouterLink } from 'react-router-dom';
// material
import {
  Card,
  Stack,
  Button,
  Container,
  Typography,
  Grid,
  SpeedDial,
  SpeedDialIcon,
  SpeedDialAction
} from '@mui/material';
// components
import Page from '../components/Page';
import { useFormik } from 'formik';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
// eslint-disable-next-line import/no-named-as-default-member
import MyDropzone from 'src/components/MyDropzone';
import axios from 'axios';
import { config } from 'src/helpers/config';
import SaveIcon from '@mui/icons-material/Save';
import authHeader from 'src/helpers/authHeader';
import 'react-datepicker/dist/react-datepicker.css';
import { NotificationManager } from 'react-notifications';

export default function Statute() {
  const save = (values) => {
    console.log(values);
    axios
      .post(
        `${config.apiAdminUrl}statute`,
        {
          ...values,
          statuteType: 'statute'
        },
        {
          headers: {
            ...authHeader()
          }
        }
      )
      .then(() => {
        NotificationManager.success('Regulamin został zaktualizowany!', '', 3000);
      })
      .catch((e) =>
        NotificationManager.error('Wystąpił błąd! Skontaktuj się z Łukaszem!', '', 3000)
      );
  };

  const formik = useFormik({
    initialValues: {
      statute: ''
    },
    onSubmit: (values) => {
      save(values);
    }
  });

  useEffect(() => {
    axios
      .get(`${config.apiAdminUrl}statute/statute`)
      .then((e) => formik.setFieldValue('statute', e.data));
  }, []);

  return (
    <Page title="User | Minimal-UI">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Regulamin
          </Typography>
          <span>
            <Button
              sx={{
                marginRight: '5px'
              }}
              variant="contained"
              component={RouterLink}
              to="/dashboard"
              startIcon={<Icon icon={skipBackOutline} />}
            >
              Wróć
            </Button>
          </span>
        </Stack>
        <Card
          sx={{
            padding: '25px'
          }}
        >
          <form onSubmit={formik.handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <CKEditor
                  editor={ClassicEditor}
                  data={formik.values.statute}
                  onReady={(editor) => {
                    // You can store the "editor" and use when it is needed.
                    console.log('Editor is ready to use!', editor);
                  }}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    formik.setFieldValue('statute', data);
                  }}
                />
              </Grid>
              <SpeedDial
                ariaLabel="SpeedDial basic example"
                sx={{ position: 'fixed', bottom: 16, right: 16 }}
                icon={<SpeedDialIcon />}
              >
                <SpeedDialAction
                  component={Button}
                  type="submit"
                  icon={<SaveIcon />}
                  tooltipTitle="Zapisz"
                />
              </SpeedDial>
            </Grid>
          </form>
        </Card>
      </Container>
    </Page>
  );
}
